@import 'common/stylesheets/mixins/common.styl'
@import 'common/stylesheets/defaults/index'

+prefix-classes('nps-survey-')
  // Keys off the sel class alone: `prefix-classes` would rewrite an `.mp-modal` qualifier here.
  .root
    border-radius $border-radius-panel
    bottom 24px
    position fixed
    right 16px
    transition bottom 0.2s $ease-in
    width 475px
    z-index $z-modal

    // TODO: Create mp-popup that does not have position absolute so that hard-coding height is not necessary.
    &.score-screen
      height 150px

    &.text-screen
      height 245px

  .content
    padding 20px 25px 10px 25px !important

    &, *
      // This is to override box-sizing: border-box which is inherited from mp-modal in browser using the shadow
      // dom polyfill.
      box-sizing content-box

    .header
      color var(--primary-text-color)
      font-size $font-size-large
      font-weight $weight-bold
      width 80%

    &.score-screen
      .scores
        display flex
        justify-content space-between
        margin-top 15px

        .score-button
          align-items center
          background-color var(--background-color)
          border 1px solid var(--component-outline-color)
          border-radius 50%
          box-shadow 0 1px 1px 0 alpha(black, 0.2)
          color var(--secondary-text-color)
          display flex
          font-size $font-size-small
          font-weight $weight-bold
          height 28px
          justify-content center
          line-height 12px
          padding 0
          width 28px

          &:hover
            background-color var(--component-hover-color)
            box-shadow 0 1px 2px 0 alpha(black, 0.23)
            color var(--blue1)
            cursor pointer

      .likeliness
        color var(--tertiary-text-color)
        display flex
        font-size $font-size-small
        font-weight $weight-medium
        justify-content space-between
        margin-top 15px

    &.text-screen
      .question
        font-size $font-size-medium
        margin-top 6px

        .label
          color var(--secondary-text-color)
          font-weight $weight-bold

        .text
          color var(--tertiary-text-color)
          font-weight $weight-medium

      .response-text-container
        display flex

        .response-text
          display block
          height 120px
          margin-top 16px
          resize none
          width 100%

      .button-container
        display flex
        justify-content flex-end
        margin-top 10px

        .submit-button
          margin-left 10px

        // Needed for browsers using shadow dom polyfill since mp-button needs border-box but the content-box
        // above overriding it
        mp-button *
          box-sizing border-box
